import React from 'react';
import styles from './Performance.module.css';

interface AH09Component extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

const AH09: AH09Component = () => {
  return (
    <div>
      <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Metric Description</div>
          <p>
            Order Cancel Rate is calculated by the number orders cancelled in the last 12 months divided by the number of orders originally ordered by your customers for the same timeframe. This includes all fulfillments (ISPU, STS, STH) but does not include any orders cancelled due to fraud or payment issues which would prevent your store from ever receiving the order.
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Supporting Details</div>
          <p>
            Find more information here:{' '}
            <a 
              href="https://acenet.aceservices.com/my-store" 
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Manage My Store
            </a>
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Goal</div>
          <p>
            5% (all purchased orders are able to be fulfilled)
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Update Cadence</div>
          <p>
            Metric is current state and updated monthly.
          </p>
        </div>

        <div className={styles.metricSection}>
          <div className={styles.sectionTitle}>Learn More</div>
          <p>
            Ensure your store is fulfilling (and therefore not cancelling) items your customers are buying from acehardware.com. Possible reasons for high store cancellation are:
            
                <ul>
                    <li>Inaccurate inventory feeding to acehardware.com</li>
                    <li>Customer decision (too long to validate stock, price, need to change product or payment method, etc.)</li>
                </ul>
            
            
            For additional guidance review the Ace Way of Retailing acehardware.com fulfillment{' '}
            <a 
              href="https://acenet.aceservices.com/awor/acehardwarecom-order-management/customer-order-fulfillment" 
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Store Procedures
            </a>
          </p>
      </div>
    </div>
  );
};

// Attach title as a static property
AH09.title = 'Order Cancel Rate';
AH09.actionTitle = 'Order Details';
AH09.actionHyperlink = 'dynamicURL:WFC:current';
export default AH09;
